import { useParams } from 'react-router-dom'

type TZoneUrlParams = { zoneAlias: string, countryCode: string, '*': string }

export function useZoneParams() {
  const { zoneAlias = '', countryCode = '', '*': rest = '' } = useParams<TZoneUrlParams>()
  return { zoneAlias, countryCode, rest }
}
